'use strict';

/**
*        
*   ---=== FlexTools ===---
*   https://zhangfisher.github.com/flex-tools
* 
*   一些实用工具函数
*
*/
function r(t){if(typeof t!="function")return !1;if(Object.prototype.toString.call(t)==="[object GeneratorFunction]"||Object.getPrototypeOf(t)===Object.getPrototypeOf(function*(){})||t.constructor.name==="GeneratorFunction")return !0;let e=t.toString();return !!/^\s*(?:function)?\*/gm.test(e)}

exports.a = r;
